import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    defaultMessage: 'Savings Insights',
    id: '5yNGla',
    description: 'Title of the automation recommendation explanation modal',
  },
  subtitle: {
    defaultMessage: 'How We Calculated What You Could Have Saved',
    id: 'jNZw9p',
    description: 'Subtitle of the automation recommendation explanation modal ',
  },
  basedOn: {
    defaultMessage: 'Based on {numberOfShipments} shipments, using {serviceName}.',
    id: 'uHSPAC',
    description: 'Explanation of the data we are basing the automation recommendation on',
  },
  youSpent: {
    defaultMessage: 'You Spent',
    id: '/rBMKj',
    description: 'Telling the user how much the spent on a certain service in the last 30 days',
  },
  last30Days: {
    defaultMessage: '(last 30 days)',
    id: 'LzEWaA',
    description: 'Visual signifier that the data is only related to the last 30 days',
  },
  ifYouSwitched: {
    defaultMessage: 'If you had used {serviceName} from ShipStation',
    id: 'Tf6Fvo',
    description: 'Telling the user how much switching to a new service could save them',
  },
  potentialSavings: {
    defaultMessage: '30 Day Total*',
    id: '5jzbU/',
    description: 'Label for potential savings number if they switched to the recommended service',
  },
  disclaimer: {
    defaultMessage: '*Savings are calculated based on the last 30 days of shipping activity',
    id: 'qH9Lr/',
    description: 'Disclaimer explaining how savings are calculated',
  },
  ctaTitle: {
    defaultMessage: 'Want to automate future savings?',
    id: '3KOww5',
    description: 'Title for the cta asking users if they would like to turn the savings into an automation rule',
  },
  cta: {
    defaultMessage: 'Talk to an Expert',
    id: 'dKPQFI',
    description: 'Text for button that open a modal to contact sales',
  },
  shipmentData: {
    defaultMessage: 'Shipment Data',
    id: 'Qzhw6W',
    description: 'Header for the shipment data table',
  },
  shipDate: {
    defaultMessage: 'Ship Date',
    id: 'C7nVWA',
    description: 'Header for the shipment date column',
  },
  orderNumber: {
    defaultMessage: 'Order #',
    id: 'F5Yo35',
    description: 'Header for the order number column',
  },
  trackingNumber: {
    defaultMessage: 'Tracking #',
    id: 'wnYSRL',
    description: 'Header for the tracking number column',
  },
  shippingAmount: {
    defaultMessage: 'Shipping Amount',
    id: 'u3r0Z+',
    description: 'Header for the shipping amount column',
  },
  potentialSavingsColumnTitle: {
    defaultMessage: 'Potential Savings',
    id: 'iE8CZD',
    description: 'Header for the potential savings column',
  },
  chevronText: {
    defaultMessage: 'View more details',
    id: 'D+SDQf',
    description: 'Text for the chevron for shipment data',
  },
});
